<template>
  <section class="hero">
    <div class="hero-body">
      <div class="container">
        <h1 class="title">
          Clublink manager
        </h1>
        <h2 class="subtitle">
          Create and manage your clublinks easily.
        </h2>
        <p class="has-text-centered">
          <sign-button size="is-large" />
        </p>
      </div>
    </div>
  </section>
</template>

<script>
import SignButton from '@/components/SignButton.vue'

export default {
  name: 'home',
  components: {
    SignButton
  }
}
</script>
